import { render, staticRenderFns } from "./CoozzyPopover.vue?vue&type=template&id=378a8a94&scoped=true"
import script from "./CoozzyPopover.vue?vue&type=script&lang=js"
export * from "./CoozzyPopover.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPopover.vue?vue&type=style&index=0&id=378a8a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a8a94",
  null
  
)

export default component.exports